import { usePathname, useUnstableGlobalHref } from 'expo-router';

const legacyRedirects: [RegExp, string][] = [
  // simple /foo/bar -> /baz
  [/^\/signup$/, '/signin'],
  [/^\/rewards\/details$/, '/rewards'],
  [/^\/store-locator\/address$/, '/store-locator/delivery-address'],
  [/^\/account\/payment\/add-card$/, '/payment/edit-card'],
  [/^\/account\/payment\/add-gift-card$/, '/payment/add-gift-card'],
  [/^\/account\/payment\/transfer-gift-card$/, '/payment/transfer-gift-card'],

  // menu routes
  [/^\/menu\/section-(.*)$/, '/menu/section'], // /menu/section-ID -> /menu/section/ID
  [/^\/menu\/item-(.*)$/, '/menu/item'], // /menu/item-ID -> /menu/section/ID
  [/^\/menu\/picker-(.*)$/, '/menu/picker'], // /menu/picker-ID -> /menu/section/ID OR /menu/picker-picker_4735 -> /menu/picker/picker_4735 etc.
  [/^\/menu\/combo-(.*)$/, '/menu/combo'], // /menu/combo-ID -> /menu/section/ID

  // complex /foo/bar* -> /baz* ETC
  [/^\/rewards\/offers(?:\/([^/]+))?$/, '/offers'], // /rewards/offers* -> /offers*
  [/^\/rewards\/list(?:\/([^/]+))?$/, '/rewards'], // /rewards/list* -> /rewards*
  [/^\/rewards\/offers-group(?:\/([^/]+))?$/, '/rewards/group'], // /rewards/offers-group/* -> /rewards/group/*
];

export const useMaybeGetLegacyRedirect = () => {
  const pathname = usePathname();
  const fullPath = useUnstableGlobalHref();

  for (const [rgx, redirect] of legacyRedirects) {
    // check if the pathname matches the regex
    const match = rgx.exec(pathname);

    if (match) {
      let redirectBuilder = match?.[1] ? `${redirect}/${match?.[1]}` : redirect;

      const queryString = fullPath.split('?')?.[1]; // not sure if we have this but just in case
      if (queryString) {
        redirectBuilder += `?${queryString}`;
      }

      if (__DEV__) {
        // eslint-disable-next-line no-console
        console.log('Legacy redirect', { from: pathname, to: redirectBuilder });
      }

      return redirectBuilder;
    }
  }

  return null;
};
